import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DataAccessFairsFacade } from '@planone/bau365/data-access-fair-data';
import {
  DataAccessSearchFacade,
  EventSearchResult,
  PostSearchResult,
  ProductSearchResult,
} from '@planone/bau365/data-access-search';
import * as DataAccessUserWatchlistActions from '@planone/bau365/data-access-user';
import { filter, map, of, switchMap, withLatestFrom } from 'rxjs';

import * as WatchlistTrackingActions from '../watchlist/watchlist.actions';

@Injectable()
export class UserEffects {
  trackItemWatchlistInteractionInSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        DataAccessUserWatchlistActions.addWatchlistItemSuccess,
        DataAccessUserWatchlistActions.removeWatchlistItemSuccess
      ),
      filter((action) => action.pageContext === 'search'),
      switchMap((watchlistItemInfo) =>
        this.SearchFacade.getSearchResultById(watchlistItemInfo.watchlistItem.entity_id).pipe(
          map((item) => ({
            item: item,
            watchlistItemInfo: watchlistItemInfo,
          }))
        )
      ),
      withLatestFrom(this.fairsFacade.trackingFairId$),
      switchMap(([data, fairId]) => {
        if (!data.watchlistItemInfo || !data.item) {
          return of();
        }

        let watchlistEvent = {
          context: fairId,
          pageType: data.watchlistItemInfo.pageContext,
        };

        let searchResult;
        if (data.watchlistItemInfo.watchlistItem.entity_type === 'PRODUCT') {
          searchResult = data.item as ProductSearchResult;
        }
        if (data.watchlistItemInfo.watchlistItem.entity_type === 'POST') {
          searchResult = data.item as PostSearchResult;
        }
        if (data.watchlistItemInfo.watchlistItem.entity_type === 'EVENT') {
          searchResult = data.item as EventSearchResult;
        }

        if (searchResult && searchResult.exhibitor_id && searchResult.exhibitor_name) {
          watchlistEvent = {
            ...watchlistEvent,
            ...(data.watchlistItemInfo.watchlistItem.entity_type === 'PRODUCT' && {
              product: { id: searchResult.id, name: searchResult.name },
              exhibitor: { id: searchResult.exhibitor_id, name: searchResult.exhibitor_name },
            }),
            ...(data.watchlistItemInfo.watchlistItem.entity_type === 'POST' && {
              post: { id: searchResult.id, headline: searchResult.name },
              exhibitor: { id: searchResult.exhibitor_id, name: searchResult.exhibitor_name },
            }),
            ...(data.watchlistItemInfo.watchlistItem.entity_type === 'EVENT' && {
              event: { id: searchResult.id, headline: searchResult.name },
              exhibitor: { id: searchResult.exhibitor_id, name: searchResult.exhibitor_name },
            }),
          };
        } else {
          watchlistEvent = {
            ...watchlistEvent,
            ...(data.watchlistItemInfo.watchlistItem.entity_type === 'EXHIBITOR' && {
              exhibitor: { id: data.item.id, name: data.item.name },
            }),
          };
        }

        const spInteractionType =
          data.watchlistItemInfo.type === DataAccessUserWatchlistActions.addWatchlistItemSuccess.type
            ? 'ADD'
            : 'REMOVE';

        return of(
          WatchlistTrackingActions.watchlistChange({
            ...watchlistEvent,
            interactionType: spInteractionType,
            contentType: data.watchlistItemInfo.watchlistItem.entity_type,
          })
        );
      })
    )
  );

  constructor(
    private readonly actions$: Actions,
    private SearchFacade: DataAccessSearchFacade,
    private fairsFacade: DataAccessFairsFacade
  ) {}
}
